export const COMMON_POPOVER_PLACEMENT = ['bottom', 'top'];
export const COMMON_TITLE_MAX_WIDTH = 533;
export const OBJECT_VALUE_PROPERTY_NAME = 'value';
